/* eslint-disable react/prop-types */
import React from 'react';
const BlurOverlay = ({ visible, onClick }) => {
    const handleClick = (e) => {
        onClick?.(e);
    };
    return (React.createElement("div", { className: `blur-overlay ${visible ? 'blur-overlay--visible' : ''} ${onClick ? 'blur-overlay--clickable' : ''}`, onClick: e => handleClick(e) }));
};
export default BlurOverlay;
